/** Couleurs des séries seuils (graphique / légende). */
export const ALARM_THRESHOLD_CHART_COLORS = {
    consigne: "#69d4b1",
    limhaute: "#ffbb8c",
    limbasse: "#e34a4a",
} as const

/** Marqueurs Plotly (`lines+markers`) : taille et pas de contour pour lisibilité. */
export const ALARM_THRESHOLD_PLOTLY_MARKER = {
    size: 6,
    line: { width: 0 },
} as const

export const ALARME_ALLOWED_BUILDING = [
    "energie_elecinjection_tout",
    "energie_elec_tout",
    "energie_gaz_tout",
    "energiepardju_elec_tout",
    "energiepardju_gaz_tout",
    "puissance_elec_tout",
    "puissance_elec_apparente",
    "cout_elec_depassementpuissance",
    "temperature_air_interieur",
    "temperature_eau_departecs",
    "temperature_eau_retourecs",
    "temperature_eau_departprimaire",
    "temperature_eau_departchauffage",
    "consignetemperature_eau_departchauffage",
    "co2_air_interieur",
    "humidite_air_interieur",

    "contact_sec_voie1",
    "contact_elec_pac",

    "energie_tout_tout",
    "energie_gaz_grdfpubliees",
    "signal_elec_reseauh+24",
]

export const ALARME_ALLOWED_SOURCE = [
    "energie_elecinjection_tout",
    "energie_elec_tout",
    "puissance_elec_tout",
    "puissance_elec_apparente",
    "cout_elec_depassementpuissance",
    "temperature_air_interieur",
    "temperature_eau_departecs",
    "temperature_eau_retourecs",
    "temperature_eau_departprimaire",
    "temperature_eau_departchauffage",
    "consignetemperature_eau_departchauffage",
    "co2_air_interieur",
    "humidite_air_interieur",

    "contact_sec_voie1",
    "contact_elec_pac",

    "energie_tout_tout",
    "energie_gaz_grdfpubliees",
    "signal_elec_reseauh+24",
]

/** Identifiant de groupe d’affichage pour le sélecteur de variable (seuils d’alarme). */
export type AlarmThresholdVariableGroupId =
    | "energy_power"
    | "indoor_air"
    | "hydraulic"
    | "contacts"
    | "grid_signal"
    | "other"

/** Ordre d’affichage des groupes dans la liste déroulante. */
export const ALARM_THRESHOLD_VARIABLE_GROUP_ORDER: readonly AlarmThresholdVariableGroupId[] =
    [
        "energy_power",
        "indoor_air",
        "hydraulic",
        "contacts",
        "grid_signal",
    ] as const

const ALARM_THRESHOLD_GROUP_ENERGY_POWER = new Set<string>([
    "energie_elecinjection_tout",
    "energie_elec_tout",
    "energiepardju_elec_tout",
    "energiepardju_gaz_tout",
    "puissance_elec_tout",
    "puissance_elec_apparente",
    "cout_elec_depassementpuissance",
    "energie_tout_tout",
    "energie_gaz_grdfpubliees",
])

const ALARM_THRESHOLD_GROUP_INDOOR_AIR = new Set<string>([
    "temperature_air_interieur",
    "co2_air_interieur",
    "humidite_air_interieur",
])

const ALARM_THRESHOLD_GROUP_HYDRAULIC = new Set<string>([
    "temperature_eau_departecs",
    "temperature_eau_retourecs",
    "temperature_eau_departprimaire",
    "temperature_eau_departchauffage",
    "consignetemperature_eau_departchauffage",
])

const ALARM_THRESHOLD_GROUP_CONTACTS = new Set<string>([
    "contact_sec_voie1",
    "contact_elec_pac",
])

const ALARM_THRESHOLD_GROUP_GRID_SIGNAL = new Set<string>([
    "signal_elec_reseauh+24",
])

/**
 * Regroupe une variable autorisée pour les seuils d’alarme (libellés du select).
 *
 * @param variableType identifiant métier `ConfigVariable.type`
 * @returns identifiant de groupe
 */
export function getAlarmThresholdVariableGroupId(
    variableType: string
): AlarmThresholdVariableGroupId {
    if (ALARM_THRESHOLD_GROUP_ENERGY_POWER.has(variableType)) {
        return "energy_power"
    }
    if (ALARM_THRESHOLD_GROUP_INDOOR_AIR.has(variableType)) {
        return "indoor_air"
    }
    if (ALARM_THRESHOLD_GROUP_HYDRAULIC.has(variableType)) {
        return "hydraulic"
    }
    if (ALARM_THRESHOLD_GROUP_CONTACTS.has(variableType)) {
        return "contacts"
    }
    if (ALARM_THRESHOLD_GROUP_GRID_SIGNAL.has(variableType)) {
        return "grid_signal"
    }
    return "other"
}
